import scanAPI from '@/domains/scan/api/scan.api';
import useSettingsStore from '@/domains/settings/store/settings.store';
import PodonexVersionChannelEnum from '@/domains/settings/typescript/enums/PodonexVersionChannelEnum';
import type { PodonexVersionEntryInterface } from '@/domains/settings/typescript/interfaces/PodonexVersionDTOInterface';

const SEMVER_REGEX = /^\d+\.\d+\.\d+/;

async function checkPodonexVersion(): Promise<PodonexVersionEntryInterface | undefined> {
    try {
        const currentPodonex = await scanAPI.hello();
        if (!currentPodonex) {
            return;
        }

        const settingsStore = useSettingsStore();
        const versionData = await settingsStore.fetchPodonexVersionData();
        if (!versionData) {
            return;
        }

        const channel = settingsStore.podonexConfiguration.podonexVersionChannel || PodonexVersionChannelEnum.STABLE;

        // Fixed version = opt-out, never show banner
        if (SEMVER_REGEX.test(channel)) {
            return;
        }

        const targetVersion =
            versionData.channels?.[channel] ?? versionData.channels?.[PodonexVersionChannelEnum.STABLE];
        if (!targetVersion) {
            return;
        }

        if (targetVersion === currentPodonex.appVersion) {
            return;
        }

        // Find the matching version entry for the download link
        const matchingEntry = versionData.versions?.find((v) => v.version === targetVersion);
        return matchingEntry;
    } catch (e) {
        console.error('Failed to check Podonex version:', e);
        return;
    }
}

export { checkPodonexVersion };
